<div class="container-fluid">
    <div class="page-title">
        <div class="row">
            <!-- Select Campaña -->
            <div class="col-lg-5 d-flex align-items-center">
                <ol id="selCampaign" class="breadcrumb me-3 mb-0 ms-3 justify-content-start">
                    <li class="breadcrumb-item font-blue dropdown drop-container">
                        <mat-spinner class="ms-2" color="accent" diameter="20"
                            *ngIf="isLoadingGeneral; else title"></mat-spinner>
                        <ng-template #title>
                            {{ this.campaignSelected?.name }}
                            <i class="ms-2 arrow down"></i>
                            <div class="drop bg-white">
                                <ul>
                                    <li (click)="setCampaignData(campaign)" class="list-item d-flex align-items-center"
                                        [ngClass]="{'selected': campaignSelected?.id === campaign.id}"
                                        *ngFor="let campaign of campaignList">
                                        <span class=" d-flex align-items-center text-truncate"
                                            href="#">{{campaign.name}}</span>
                                        <mat-icon *ngIf="campaignSelected?.id === campaign.id"
                                            class="check-icon d-flex align-items-center ms-auto me-2">check</mat-icon>
                                    </li>
                                </ul>
                            </div>
                        </ng-template>
                    </li>
                </ol>
                <button *ngIf="objLineasEstaciones != undefined " class="btn-no-space ms-2" mat-icon-button
                    matTooltip="Actualizar información" (click)="reloadData()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
            <!-- Info en el header -->
            <div class="col-lg-7 d-flex align-items-center justify-content-end">
                <div class="row col-lg-12">
                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12 text-end">
                    <button *ngIf="objLineasEstaciones != undefined " class="btn-no-space"
                        mat-icon-button
                        color="accent"
                        aria-label="Ver historial" 
                        matTooltip="Ver historial"
                        (click)="openModalHistory()">
                        <mat-icon>history</mat-icon>
                    </button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-center">
                    <strong class="me-2">Compañía:</strong> {{this.compania}}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
                    <strong class="me-2">Fecha inicio:</strong> {{ this.fecha_inicio ?
                        (this.fecha_inicio | date: 'dd/MM/yyyy') : '' }}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
                    <strong class="me-2">Fecha fin:</strong> {{ this.fecha_fin ?
                        (this.fecha_fin | date: 'dd/MM/yyyy') : '' }}
                </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoadingGeneral"
        style="display: flex; justify-content: center; align-items: center; background: white;">
        <mat-progress-bar color="accent" mode="indeterminate">
        </mat-progress-bar>
    </div>

    <!-- Contendido -->
    <div class="container-fluid" *ngIf="objLineasEstaciones != undefined ">
        <div class="row mt-4">
            <div class="col-md-3">
                <div *ngFor="let linea of lineas; let i = index" class="linea-card-container" [class.dimmed]="lineaSeleccionadaId !== 0 && lineaSeleccionadaId !== linea.line" (click)="seleccionarLinea(linea.line)" [ngStyle]="{'background-color': linea.color, 'border': linea.line === lineaSeleccionadaId ? '3px solid ' + linea.colorBorde : 'none'}">

                    <mat-card class="linea-card">
                        <mat-card-content>
                            <div class="d-flex align-items-center">
                                <h6 class="mb-0">Línea {{ linea.line }}</h6>
                                <mat-icon class="ms-auto" (click)="movInventario(linea)">sync_alt</mat-icon>
                            </div>
                            <p class="mb-1"> <label class="fw-bold" style="cursor: pointer">Estaciones:</label> {{linea.estaciones}}</p>
                            <p class="mb-0"> <label class="fw-bold" style="cursor: pointer">Alertas:</label> {{linea.alertas}}</p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <div class="col-md-9">
    
                <div class="card d-flex justify-content-center align-items-center" style="height: 50px;">
                    <h6 class="fw-bold">Estaciones</h6>
                </div>

                <div *ngIf="selectedLinea" class="row g-2">
                    <div *ngFor="let linea_e of datosLineas" class="col-md-3">
                        <div class="" style="border-radius: 8px; cursor: pointer" [class.dimmed]="estacionSeleccionada !== '' && estacionSeleccionada !== linea_e.nombre" (click)="seleccionarEstacion(linea_e)" [ngStyle]="{'background-color': linea_e.color, 'border': linea_e.nombre === estacionSeleccionada ? '2px solid ' + linea_e.colorBorde : 'none'}">
                              
                            <mat-card-content class="d-flex align-items-center justify-content-center">
                                <div class="text-center">
                                    <h6>{{linea_e.nombre.replace('Estacion', 'Estación')}}</h6>
                                </div>
                            </mat-card-content>
                            
                        </div>
                    </div>
                </div>

                <div *ngIf="!selectedLinea" class="table-wrapper">
                    <table  class="table table-sm mb-0">
                        <thead>
                            <tr>
                                <th class="fw-bold">Estación</th>
                                <th class="fw-bold">Línea</th>
                                <th class="fw-bold">Cantidad de productos</th>
                                <th class="fw-bold">Cantidad de alertas</th>
                                <th class="fw-bold">Comparte inventario con</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let est of objEstaciones">
                                <td>{{est.estacion.replace('Estacion', 'Estación')}}</td>
                                <td>{{est.line}}</td>
                                <td>{{est.comparte == null ? est.cantidad_total : '-'}}</td>
                                <td>{{est.alertas}}</td>
                                <td>{{est.comparte != null ? est.comparte.replace('Estacion', 'Estación') : ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
    
                <div class="card d-flex justify-content-center align-items-center mt-4"  style="height: 50px;">
                    <h6 class="fw-bold">Materiales</h6>
                </div>
                <div *ngIf="!selectedLinea" class="table-wrapper mb-4">
                    <table  class="table table-sm mb-0">
                        <thead>
                            <tr>
                                <th class="fw-bold">Material</th>
                                <th class="fw-bold">SKU</th>
                                <th class="fw-bold">Cantidad en rack</th>
                                <th class="fw-bold">Cantidad a utilizar</th>
                                <th class="fw-bold">Cantidad en inventario</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mat of objMateriales">
                                <td>{{mat.nombre_mat}}</td>
                                <td>{{mat.sku}}</td>
                                <td>{{mat.cantidad}}</td>
                                <td>{{mat.cantidad_total}}</td>
                                <td>{{mat.actual}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                


                <div class="row g-2 mb-4" *ngIf="selectedEstacion">

                    <div *ngIf="tipo_estacion != 'BG' " class="grid-container" [ngStyle]="{'grid-template-columns': 'repeat(' + columnas_materiales + ', 1fr)'}">
  
                        <div class="grid-item" *ngFor="let mat of grid_mat" (click)="openRellenoMaterial(mat,'g')" style="cursor:pointer" [ngStyle]="{'background-color': mat.color}">
                            
                            <div *ngIf="mat.nombre_mat">
                                <h6>{{ mat.nombre_mat }}</h6>
                                <span class="badge rounded-pill custom-bootstrap-badge" [ngStyle]="{'background-color': mat.color2}">
                                    {{mat.cantidad}}/{{mat.cantidad_total}}
                                </span>
                            </div>
                            
                        </div>

                    </div>

                    <div *ngIf="tipo_estacion == 'BG' ">
  
                        <table class="table mb-0">
                            <tbody>
                                <tr *ngFor="let mat of grid_mat"  style="cursor:pointer" [ngStyle]="{'background-color': mat.color}">
                                    <td class="text-center" (click)="openRellenoMaterial(mat,'bg')">
                                        {{mat.nombre_mat}}
                                        <span class="badge rounded-pill custom-bootstrap-badge ms-3" [ngStyle]="{'background-color': mat.color2}">
                                            {{mat.cantidad}}/{{mat.cantidad_total}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
    
            </div>
    
        </div>
    </div>

    <div *ngIf="objLineasEstaciones == undefined" class="mt-5 d-flex align-items-center justify-content-center">
        <label>No se ha cargado el archivo de acomodo de racks para esta campaña</label>
    </div>


</div>
    



